import React from 'react';
import ReactDOM from 'react-dom';
import '@src/common/resetMobile.css';
import Layout from './layout';
import { InformationFlow } from 'ThreeTerminal_mobile_dynamic';

const preLoadDynamic = [InformationFlow.preload()];

/* eslint-disable */
Promise.all(preLoadDynamic).then(() => {
    ReactDOM.hydrate(<Layout content={allData} />, document.getElementById('root'));
});
/* eslint-enable */
